module.exports = __webpack_public_path__ + "img/be.3911e782.svg";